import LayoutCustomer from "../../../layout/LayoutCustomer";
import { AdminContext } from "./context";

export default ({ user }) => {
  
  return (
    <AdminContext.Provider value={user}>
      <LayoutCustomer user={user} />
    </AdminContext.Provider>
  );
};
